import React from 'react'
import { Box, Button, Icon, RadioInput, RadioLabel, Text } from '@maui/elements'
import { useEodDrawer } from '../../providers/EodDrawerContext'
import { InfoTooltip } from '../common/Tooltip'
import { StepNavigator } from '../common/StepNavigator'

export default function NewRequest() {
  const { state, dispatch, mode } = useEodDrawer()
  const { setSelectedRequestType, onClose, setRequestType } = dispatch

  const onNextStep = () => {
    setRequestType(state.selectedRequestType)
  }

  return (
    <>
      {mode === 'drawer' &&
        <StepNavigator>
          <Box display='flex' flex='1' alignItems='center'>
            <Text variant='heading5' height='spaceGapLarge'>
              Select an option below and select &ldquo;Next&ldquo;
            </Text>
          </Box>
          <Box display='flex' flexDirection='column' alignItems='center'>
            <Box>
              <Button variant='secondary' onClick={onClose} mx={0}>
                Cancel
              </Button>
              <Button marginLeft='spaceGapLarge' onClick={onNextStep} disabled={state.disableNext}>
                <Box display="flex">
                  Next
                  <Icon name='left-arrow' size="sm" ml="10px" mt="1px" style={{ transform: 'rotate(-180deg)' }}/>
                </Box>
              </Button>
            </Box>
          </Box>
        </StepNavigator>
      }

      <Box marginTop="16px" marginBottom="16px">
        <Text mb={16}>You can ask our experts any cyber-security related or subscription related questions.</Text>
        <Text mb={16}>
          If your request is related to a suspected or ongoing breach, then please {' '}
          <Text as="a" color="colorActionPrimary" href="https://www.mandiant.com/report-incident" target="_blank">
          contact our incident response teams
          </Text>
          . An Incident Responder will contact you within your pre-defined service level agreement timelines
        </Text>
      </Box>

      <Box display='flex' flexDirection='row' alignItems='center' flex="1">
        <Text variant="heading5">
          Requests
        </Text>
        <Box borderTop='0.5px solid' borderColor='colorBorderMain' width='60%' ml='10px' flex="1"></Box>
      </Box>

      <Box marginTop="24px">
        <form>
          <Box display="flex" alignItems="center" my="spaceGapLarge">
            <RadioLabel mb='0' padding='0'>
              <RadioInput
                mr='spaceGapSmall'
                value="analystInvestigation"
                name="AnalystInvestigationForm"
                onChange={() => setSelectedRequestType('analystInvestigation')}
                checked={state.selectedRequestType === 'analystInvestigation'}
                id="analystInvestigation"
              />
              Analyst Investigation Form
            </RadioLabel>
            <InfoTooltip
              ml="spaceGapMedium"
              tooltip='Allows you to provide detailed information to support an analyst investigation.'
            />
          </Box>
          <Box display="flex" alignItems="center" marginTop="12px" marginBottom="12px">
            <RadioLabel mb='0' padding='0'>
              <RadioInput
                mr='spaceGapSmall'
                value='freeFormRequest'
                name="FreeformForm"
                onChange={() => setSelectedRequestType('freeform')}
                checked={state.selectedRequestType === 'freeform'}
                id="freeFormRequest"
              />
              Free-Form Request
            </RadioLabel>
            <InfoTooltip
              ml="spaceGapMedium"
              tooltip='Describe your request, please include any special considerations we should be aware of.'
            />
          </Box>
        </form>
        {mode === 'page' &&
          <Button onClick={onNextStep} disabled={state.disableNext} mt="16px">
            <Box display="flex" alignItems="center" gap="10px">
              Next <Icon name='left-arrow' size="sm" transform="rotate(-180deg)" />
            </Box>
          </Button>
        }
      </Box>
    </>
  )
}
